import { isSuccess } from '@devexperts/remote-data-ts'
import { createSelector } from '@reduxjs/toolkit'
import { licenseSlice } from '..'

export const afternoonMainTimeSlotSelector = createSelector(
  [licenseSlice.selectors.mainTimeSlots],
  (mainTimeSlots) => {
    if (!isSuccess(mainTimeSlots)) {
      return null
    }

    return mainTimeSlots.value.find((ts) => ts.name === 'afternoon')
  }
)
